import { Link } from 'react-router-dom';

export default function LinkButton({ children, ...props }) {
	return <Link className="scl-button scl-button-secondary" {...props}>{children}</Link>;
}